import { notify } from "./notify";
import { api } from "./../app";
export const updateCache = keys => {
	notify(`Caching and reindexing ${keys.join(", ")} <span uk-spinner></span>`, "primary", "top-right", 60000, "cache update");
	return new Promise(async (resolve, reject) => {
		try {
			const response = await $.ajax({
				method: "POST",
				url: `${api}/request`,
				headers: {
					"Content-Type": "application/json"
				},
				xhrFields: {
					withCredentials: true
				},
				data: JSON.stringify({
					reqId: "ae6c1c67-0669-48b0-b1d5-730122d23d44",
					sources: keys
				})
			});
			if (response.success) {
				notify("Cache update complete", "success", "top-right", 3000, "", "cache update", true);
				resolve();
			} else {
				throw response.data;
			}
			resolve();
		} catch (err) {
			notify(`There was an error updating the cache: ${err}`, "danger", "top-right", 3000, "", "cache update", true);
			reject(err);
		}
	});
};
// end updateCache function
